"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    position: relative;\n    outline: 0 none;\n    border: 0 none;\n    padding: 0;\n    margin: 0;\n    z-index: 4;\n    transition-property: background, box-shadow;\n    ", ";\n\n    &:after {\n        content: '';\n        display: block;\n        position: absolute;\n        top: 0;\n        right: 0;\n        transition-property: transform, background;\n        transform: scale(0);\n        transform-origin: center;\n        opacity: 0.38;\n        z-index: 3;\n        ", ";\n    }\n    &:hover:after {\n        transform: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      focused = _ref.focused;
  var palette = theme.palette;
  return {
    width: theme.pointerWidth,
    height: theme.pointerHeight,
    background: disabled ? theme.disabledPointerBackground : focused ? theme.focusPointerBackground : theme.pointerBackground,
    boxShadow: disabled ? theme.disabledPointerBoxShadow : focused ? theme.focusPointerBoxShadow : theme.pointerBoxShadow,
    borderRadius: theme.pointerBorderRadius,
    cursor: disabled ? 'not-allowed' : 'move',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    '&:after': {
      content: '""',
      display: 'block',
      width: theme.pointerWidth,
      height: theme.pointerHeight,
      background: theme.pointerBackground,
      position: 'absolute',
      borderRadius: theme.pointerBorderRadius,
      top: 0,
      right: 0,
      transitionProperty: 'transform, background',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction
    },
    '&:hover:after': disabled ? null : {
      transform: 'scale(2)'
    }
  };
};

var after = function after(_ref2) {
  var theme = _ref2.theme;
  var palette = theme.palette;
  return {
    width: theme.pointerWidth,
    height: theme.pointerHeight,
    background: theme.pointerBackground,
    borderRadius: theme.pointerBorderRadius,
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction
  };
};

var Pointer = _styledComponents["default"].button(_templateObject(), function (props) {
  return base(props);
}, function (props) {
  return after(props);
}, function (props) {
  return props.disabled ? null : 'scale(2)';
});

var _default = Pointer;
exports["default"] = _default;